import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/NewsFeeds/Standards/(1).jpeg";
import Card3 from "../Images/NewsFeeds/Standards/(4).jpeg";
import Card4 from "../Images/NewsFeeds/Standards/(2).jpeg";
import Card5 from "../Images/NewsFeeds/Standards/(5).jpeg";

function AdvancingStandardsCleanCooking() {
  return (
    <div className="art-page">
      <SEO
        title="Advancing Standards for Clean Cooking in Uganda"
        description="CIRCODU led the development of national standards for institutional cookstoves and biogas systems in Uganda, engaging stakeholders through sensitization workshops to ensure standards reflect community needs."
        keywords="standards, clean cooking, cookstoves, biogas, Uganda, CIRCODU, institutional cooking, clean cooking standards Uganda, biogas standards Uganda, institutional cookstove standards Uganda, UNBS clean cooking standards, MEMD clean cooking standards, UECCC clean cooking standards, clean cooking stakeholder engagement Uganda, clean cooking sensitization workshops Uganda, clean cooking standard development process Uganda, clean cooking standard review Uganda, clean cooking standard public consultation Uganda, clean cooking standard implementation Uganda, clean cooking standard impact Uganda, clean cooking standard compliance Uganda, clean cooking standard enforcement Uganda, clean cooking standard benefits Uganda"
        url="/Advancing-Standards-for-Clean-Cooking-in-Uganda"
        image={Card1}
        datePublished="2026-02-19"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Advancing Standards for Clean Cooking in Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 19, 2026
            </div>

            <h1 className="art-title">
              Advancing Standards for Clean Cooking in Uganda
            </h1>

            <div className="texty">
              <p>
                Standards are the invisible backbone of any credible clean
                cooking ecosystem. They define what is safe, what is efficient,
                and what communities can trust. In a significant step forward
                for Uganda's clean cooking sector, the{" "}
                <strong>
                  Centre for Integrated Research and Community Development
                  Uganda (CIRCODU)
                </strong>
                , together with the{" "}
                <strong>Uganda National Bureau of Standards (UNBS)</strong> and
                the{" "}
                <strong>
                  Ministry of Energy and Mineral Development (MEMD)
                </strong>
                , with financial support from the{" "}
                <strong>
                  Uganda Energy Credit Capitalisation Company (UECCC)
                </strong>
                , successfully convened a critical standards review meeting.
              </p>
              <img
                src={Card1}
                alt="Team that reviewed the standards"
                className="art-img"
              />
              <h2 className="art-subheading">The Meeting</h2>
              <p>
                The{" "}
                <strong>
                  UNBS/TC 107 Mechanical Engineering Technical Committee
                </strong>{" "}
                met from <strong>5th to 6th February 2026</strong> at J-FRIGH
                Hotel, Makerere Kikoni, Kampala. The session was focused on
                carefully considering and incorporating comments received during
                the public review of two comprehensive draft Ugandan standards
                for clean cookstoves and clean cooking solutions, specifically:
              </p>
              <ol>
                <li>
                  <strong>DUS 2688:2025</strong> – Biogas systems —
                  Institutional cooking and non-gasification
                </li>
                <li>
                  <strong>DUS 2689:2025</strong> – Clean cookstoves and clean
                  cooking solutions — Institutional biomass cookstove —
                  Specification
                </li>
              </ol>
              <img
                src={Card3}
                alt="Team members during the review of the standards"
                className="art-img"
              />
              <img
                src={Card5}
                alt="Team members reviewing the standards"
                className="art-img"
              />
              <h2 className="art-subheading">A Collaborative Achievement</h2>
              <p>
                The success of this meeting reflects the strength of
                multi-institutional collaboration. Our sincere gratitude goes to
                the dedicated team drawn from a broad range of institutions,
                whose commitment ensured that all public input was fully
                addressed and faithfully reflected in the evolving standards:
              </p>
              <ol>
                <li>Uganda National Bureau of Standards (UNBS)</li>
                <li>Ministry of Energy and Mineral Development (MEMD)</li>
                <li>Uganda Energy Credit Capitalisation Company (UECCC)</li>
                <li>Makerere University, School of Engineering</li>
                <li>Kyambogo University Engineering Society (KYUES)</li>
                <li>National Water &amp; Sewerage Corporation (NWSC)</li>
                <li>
                  Ministry of Agriculture, Animal Industry and Fisheries (MAAIF)
                </li>
                <li>
                  Science, Technology and Innovation Secretariat of Uganda –
                  Office of the President (STI-OP)
                </li>
                <li>Uganda Institution of Professional Engineers (UIPE)</li>
              </ol>
              <p>
                Together, we continue to lay a strong, credible, and inclusive
                foundation for safe and clean cooking solutions in Uganda.
                Standards shaped by many voices are standards that truly serve
                everyone.
              </p>
              <p>
                <em>For God and Our Country.</em>
              </p>
              <img
                src={Card4}
                alt="Team members that reviewed the standards"
                className="art-img"
              />
            </div>

            <div className="art-cta">
              <p>
                For more information on Uganda's clean cooking standards
                development process, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AdvancingStandardsCleanCooking;
